import { getPermissionFlags } from './getPermissionFlags';

const initialState = {
  webhookCollections: [],
  permissionFlags: null,
  webhookList: [],
  webhookDetails: null,
  totalWebhookPages: 0,
  createWebhookPending: false,
  createWebhookError: null,
  loadCollectionForWebhookPending: false,
  loadCollectionForWebhookError: null,
  listWebhooksPending: false,
  listWebhooksError: null,
  loadWebhookDetailsPending: false,
  loadWebhookDetailsError: null,
  updateWebhookPending: false,
  updateWebhookError: null,
  deleteWebhookPending: false,
  deleteWebhookError: null,
  getPermissionFlagsPending: false,
  getPermissionFlagsError: null,
};

export default initialState;
